import styles from './Card.module.scss'

const Card = ({ image, title, desc }) => {

  return (
    <section>
      <div>
        <img src={image} alt="" className={styles['img']} />
      </div>
      <div>
        {title}
      </div>
      <div className="text-center">
        {desc}
      </div>
    </section>
  )

}

export default Card